import { OrderMessageOrigin } from '../enums/order-message-origin.enum';

export interface IOrderMessage {
  id: string;
  content: string;
  displayName: string;
  origin: OrderMessageOrigin;
  createdAt: string;
}
